import { ERC20 } from "../abi/ERC20";
import { createReadOnlyContract } from "../utils";

export const callViewFunction = (
  chainId: number,
  addressContract: string,
  params: any[],
  fnToCall: string,
  abi?: any,
  callback?: any
) => {
  const contract = createReadOnlyContract(
    chainId,
    abi || ERC20,
    addressContract
  );

  return contract.methods[fnToCall](...params)
    .call()
    .then((response) => {
      console.debug(`${fnToCall} transaction sent successfully`);
      return callback ? callback(response) : response;
    });
};
